import * as Yup from "yup";

let validationSchema = Yup.object({
  confirm_code: Yup.string().required("Confirm Code is Required"),
});
export default validationSchema;
